import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import startOfToday from 'date-fns/start_of_today';
import isValidJsonString from '../../../utils/is-valid-json-string';
import { ymd } from '../../../utils/date';
import calendar from '../../calendar-modal';
import { PAYMENTS_PATH } from './constant';
import orderBy from 'lodash/orderBy';
import Guid from '../../../utils/guid';
import { encode } from 'base-64';
import { EBANKINGWEBLUX, EBANKINGWEBUK } from '../../../constants';
import envConfig  from '../../../../db-env-build';

const today = startOfToday();
const testDate = (from, to, tx) => {
  if (!from && !to) return true
  const thisDate = tx.executionDate
  const res = (from ? from<=thisDate : true) && 
    (to ? thisDate<=to : true)
  return res
}
const testAmount = (from, to, tx) => {
  if (!from && !to) return true
  const thisAmount = tx.debitAmount
  const res = (from ? from<=thisAmount : true) && 
    (to ? thisAmount<=to : true)
  return res
}
const testCurrency = (isoCode, tx) => {
  if (!isoCode) return true
  const thisIsoCode = tx.currency.isoCode
  return isoCode.includes(thisIsoCode)
}
// todo test local
const testPortfolio = (pfId, tx) => {
  if (!pfId) return true
  if (!tx.debitAcc || !tx.debitAcc.pfId) return false
  const thisPfId = tx.debitAcc.pfId
  return pfId === thisPfId
}
const testDebitAccount = (accNo, tx) => {
  if (!accNo) return true
  if (!tx.debitAcc || !tx.beneficiaryDetails.accountNo) return false
  const thisAccNo = tx.debitAcc.accNo
  return accNo === thisAccNo
}
const testBeneficiaryName = (pattern, tx) => {
  if (!pattern) return true // default value
  if (!tx.beneficiaryDetails) return false
  const { firstName, lastName } = tx.beneficiaryDetails
  const re = new RegExp(pattern, 'i')
  const res = re.test(firstName) || re.test(lastName)
  return res
}
const testType = (typeDesc, tx) => {
  if (!typeDesc) return true
  if (!tx.paymentType || !tx.paymentType.paymentTypeDesc) return false
  const thisTypeDesc = tx.paymentType.paymentTypeDesc
  const res = thisTypeDesc === typeDesc
  return res
}
// todo test local
const testStatus = (status, tx) => {
  if (!status) return true
  if (!tx.paymentStatus || !tx.paymentStatus.dwoStatus) return false
  const thisStatus =  tx.paymentStatus.dwoStatus.toUpperCase()
  return thisStatus === status
}
export default () =>
  muster()
    .path('payments.setFilterDataSource', {
      call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));
        const [portfolios] = await getValues(get('app.user.portfoliosData'));
        const portfolioList = portfolios.map((portfolio) => portfolio.title);
        set('payments.portfolioListData', portfolioList);
        let debitAccounts = []
        let paymentTypes = []
        let paymentStatus = []
        let currencies = []
        const [result] = await getValues(get(`${PAYMENTS_PATH}.filterListsLookup`));

        await isValidJsonString(result)
          .then(data => {
            if(envConfig.envConfig === EBANKINGWEBLUX){
              const luxPaymentTypeList= data.paymentTypeList.filter((paymentType) => (paymentType !== messages['app.payments.domestic'] && paymentType !==  messages['app.payments.qrBillPayment']));
              paymentTypes = paymentTypes.concat(luxPaymentTypeList || []);
            }else if(envConfig.envConfig === EBANKINGWEBUK){
              const ukPaymentTypeList= data.paymentTypeList.filter((paymentType) => (paymentType !== messages['app.payments.sepa'] && paymentType !==  messages['app.payments.qrBillPayment']));
              paymentTypes = paymentTypes.concat(ukPaymentTypeList || []);
            }else{
              paymentTypes = paymentTypes.concat(data.paymentTypeList || []);
            }
            debitAccounts = debitAccounts.concat(data.debitAccountList || []);
            paymentStatus = paymentStatus.concat(data.paymentStatusList || []);
            currencies = currencies.concat(data.currencyList && data.currencyList.map((currency) => `${currency.key} - ${currency.value}`) || []);
            return null;
          })
          .catch(() => {});
        set('payments.debitAccountListData', debitAccounts);
        set('payments.paymentTypeListData', paymentTypes);
        set('payments.statusListData', paymentStatus);
        set('payments.currencyListData', currencies);
      },
    })
    .path('payments.applyFilter', {
      call: async ({ req }, { get, set }) => {
        const opts = req.args[0];
        await set('payments.filterOptions', opts);
        
        // EBANK-11646 - Make api call to get filter results
        set('payments.transactionListLoading', true);
        const channel = 'WEB';
        const deviceCode = '';

        const filterOpts=( ({filters,selectedExecDate,beneficiaryName,currency,...filteredOpts})=>({...filteredOpts}) )(opts);
        const filterLookUp = encode(JSON.stringify(filterOpts));
        const inputs = `${deviceCode}#@#${channel}#@#${filterLookUp}`;
        const url = `${PAYMENTS_PATH}.listTransactions.["${inputs}"]["${Guid()}"]`;
       
        const [result] = await getValues(get(url));
        try {
          const filtered = JSON.parse(result).resultList;
          
          // Filter BeneficiaryName and currency on UI
          const filteredList = filtered.filter(e => 
            testBeneficiaryName(opts.beneficiaryName, e) &&
            testCurrency(opts.currency, e) 
          );

          set('payments.filterFlag', true);        
          await set('payments.filteredPayments', orderBy(filteredList, 'executionDate', 'desc'));
        } catch (e) { 
            set('payments.filteredPayments', []);
        }
        set('payments.transactionListLoading', false); 
      },
    })
    .path('payments.onFilterCalendarDone', {
      call: async ({ req }, { set }) => {
        const startDate = req.args[0].fromDate
          ? req.args[0].fromDate
          : req.args[0].toDate;
        const endDate = req.args[0].toDate
          ? req.args[0].toDate
          : req.args[0].fromDate;
        if (startDate) {
          await set('payments.filterStartDate', ymd(startDate));
          await set('payments.filterEndDate', ymd(endDate));
        }
      },
    })

    .import('payments.filterCalendar', calendar(), {
      onDone: ref('payments.onFilterCalendarDone'),
    })

    .path('payments.filterFlag', variable(false))
    .path('payments.filteredPayments', variable(null))
    .path('payments.portfolioListData', variable(null))
    .path('payments.debitAccountListData', variable(null))
    .path('payments.paymentTypeListData', variable(null))
    .path('payments.statusListData', variable(null))
    .path('payments.currencyListData', variable(null))
    .path('payments.filterStartDate', variable(today))
    .path('payments.filterEndDate', variable(today))
    .path('payments.filterOptions', variable(null))

